import Lookup from './lookup.js';

export default class BodyMainPart extends Lookup
{
    
}
